import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import Checkbox from '../../../../../../components/Form/Checkbox'

import { CREATIVE_ASSETS_DATE, LOGO_DATE, REQUEST_CREATIVE_ASSETS, REQUEST_LOGO } from '../../fields'

import DatePicker from '../../../../../../components/DatePicker'

import useDrawerFormStyles from '../../../../../../styles/common/drawerForms'

function RequestAssetsSection({ formik }) {
  const drawerFormClasses = useDrawerFormStyles()

  const { t } = useTranslation()

  const { values, setFieldValue } = formik

  const handleCreativeAssetsDateChange = useCallback(
    value => {
      setFieldValue(CREATIVE_ASSETS_DATE, value)
    },
    [setFieldValue]
  )

  const handleLogoDateChange = useCallback(
    value => {
      setFieldValue(LOGO_DATE, value)
    },
    [setFieldValue]
  )

  return (
    <section className={drawerFormClasses.section}>
      <h3 className={drawerFormClasses.sectionTitle}>Request creative assets from partner</h3>
      <p>To request creative assets and or logo file(s) from the partner, please check the boxes below:</p>
      <Checkbox
        id="checkbox_request_creative_assets"
        title="Request creative assets"
        checked={values[REQUEST_CREATIVE_ASSETS]}
        onCheck={() => setFieldValue(REQUEST_CREATIVE_ASSETS, !values[REQUEST_CREATIVE_ASSETS])}
      />
      {values[REQUEST_CREATIVE_ASSETS] && (
        <DatePicker
          className={drawerFormClasses.dateTimeInput}
          placeholder={t('Deadline date (optional)')}
          value={values[CREATIVE_ASSETS_DATE]}
          minDate={new Date()}
          changeHandler={handleCreativeAssetsDateChange}
        />
      )}
      <Checkbox
        id="checkbox_request_logo"
        title="Request logo file(s)"
        checked={values[REQUEST_LOGO]}
        onCheck={() => setFieldValue(REQUEST_LOGO, !values[REQUEST_LOGO])}
      />
      {values[REQUEST_LOGO] && (
        <DatePicker
          className={drawerFormClasses.dateTimeInput}
          placeholder={t('Deadline date (optional)')}
          value={values[LOGO_DATE]}
          minDate={new Date()}
          changeHandler={handleLogoDateChange}
        />
      )}
    </section>
  )
}

export default RequestAssetsSection
